if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const isComingSoon =
          this.dataset.comingSoon === 'true' ||
          this.submitButton.dataset.comingSoon === 'true';

        if (isComingSoon) {
          return;
        }

        if (
          this.submitButton.disabled ||
          this.submitButton.hasAttribute('disabled') ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        /*
         * Ask Shopify to return the updated cart icon
         * together with the add-to-cart response.
         */
        formData.append(
          'sections',
          'cart-icon-bubble'
        );

        formData.append(
          'sections_url',
          window.location.pathname
        );

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (soldOutMessage) {
                this.submitButton.setAttribute(
                  'aria-disabled',
                  true
                );

                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            }

            this.error = false;

            /*
             * Update the cart icon immediately.
             */
            this.updateCartIcon(response.sections);

            /*
             * Notify Shopify/theme components that the cart changed.
             */
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            /*
             * If using cart drawer/notification, keep
             * Sense's normal behavior.
             */
            if (this.cart) {
              const startMarker =
                CartPerformance.createStartingMarker(
                  'add:wait-for-subscribers'
                );

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });

              const quickAddModal =
                this.closest('quick-add-modal');

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure(
                        'add:paint-updated-sections',
                        () => {
                          this.cart.renderContents(response);
                        }
                      );
                    });
                  },
                  { once: true }
                );

                quickAddModal.hide(true);
              } else {
                CartPerformance.measure(
                  'add:paint-updated-sections',
                  () => {
                    this.cart.renderContents(response);
                  }
                );
              }

              return;
            }

            /*
             * CART TYPE = PAGE
             *
             * Stay on the current page and show
             * our confirmation floater.
             */
            this.showAddedMessage();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector(
              '.loading__spinner'
            ).classList.add('hidden');

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      updateCartIcon(sections) {
        if (!sections || !sections['cart-icon-bubble']) {
          return;
        }

        const html = sections['cart-icon-bubble'];

        const parser = new DOMParser();

        const doc = parser.parseFromString(
          html,
          'text/html'
        );

        const newCartIcon =
          doc.querySelector('#cart-icon-bubble');

        const currentCartIcon =
          document.querySelector('#cart-icon-bubble');

        if (newCartIcon && currentCartIcon) {
          currentCartIcon.replaceWith(newCartIcon);
        }
      }

      showAddedMessage() {
        const existingMessage =
          document.querySelector('.cart-added-floater');

        if (existingMessage) {
          existingMessage.remove();
        }

        const message =
          document.createElement('div');

        message.className =
          'cart-added-floater';

        message.innerHTML = `
          <div class="cart-added-floater__content">

            <div class="cart-added-floater__check">
              ✓
            </div>

            <div class="cart-added-floater__text">
              <strong>Added to your cart</strong>
            </div>

          </div>

          <div class="cart-added-floater__actions">

            <a href="${window.routes.cart_url}">
              View cart
            </a>

            <button
              type="button"
              class="cart-added-floater__close"
              aria-label="Close"
            >
              ×
            </button>

          </div>
        `;

        document.body.appendChild(message);

        requestAnimationFrame(() => {
          message.classList.add('is-visible');
        });

        const closeButton =
          message.querySelector(
            '.cart-added-floater__close'
          );

        const removeMessage = () => {
          message.classList.remove('is-visible');

          setTimeout(() => {
            if (message.parentNode) {
              message.remove();
            }
          }, 300);
        };

        closeButton.addEventListener(
          'click',
          removeMessage
        );

        setTimeout(
          removeMessage,
          5000
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}